<template>
  <div class="card">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">LXD</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            <a href="javascript:void(0)">Logs</a>
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-header"></div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <h4 class="fw-600 mt-0 mb-0">Logs</h4>
        </div>
        <div class="col-md-12 d-flex justify-content-end mb-2">
          <button :disabled="refreshing" class="btn btn-primary" type="button" @click="refreshLogs">
            <i :class="refreshing ? 'fa fa-spin fa-spinner' : 'fa fa-refresh'" class="mr-1"></i>
            Refresh
          </button>
        </div>
        <div class="col-md-12">
          <table id="lxd_logs_datatable" cellspacing="0" class="table table-striped table-bordered table-responsive" width="100%">
            <thead class="thead-dark">
            <tr>
              <th>Instance</th>
              <th class="text-center">Cluster</th>
              <th class="text-center">Node Group</th>
              <th class="text-center">Status</th>
              <th class="text-center">Source &rarr; Target Node</th>
              <th class="text-center">Started</th>
              <th class="text-center">Completed</th>
              <th class="text-center">Elapsed</th>
              <th class="text-center" style="min-width: 460px;">Action</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
              <th>Instance</th>
              <th class="text-center">Cluster</th>
              <th class="text-center">Node Group</th>
              <th class="text-center">Status</th>
              <th class="text-center">Source &rarr; Target Node</th>
              <th class="text-center">Started</th>
              <th class="text-center">Completed</th>
              <th class="text-center">Elapsed</th>
              <th class="text-center">Action</th>
            </tr>
            </tfoot>
            <tbody v-show="!loader">
            <tr v-for="(row, index) in logs" :key="index">
              <td width="10%">
                <a href="javascript:void(0)" @click="openDetails(row)">{{ row.instance }}</a>
              </td>
              <td class="text-center">{{ row.cluster || '-' }}</td>
              <td class="text-center">{{ row.node_group || '-' }}</td>
              <td class="text-center">
                <span :class="statusBadgeClass(row.status)"
                      class="badge badge-pill badge-rounded">{{ formatStatus(row.status) }}</span>
              </td>
              <td class="text-center">
                <span class="fw-semibold">{{ row.source_node || '-' }}</span>
                <i class="fa fa-long-arrow-right mx-1 text-muted"></i>
                <span class="fw-semibold">{{ row.target_node || '-' }}</span>
              </td>
              <td :data-order="row.started_at" class="text-center">{{ formatDate(row.started_at) }}</td>
              <td :data-order="row.completed_at" class="text-center">{{ formatDate(row.completed_at) }}</td>
              <td class="text-center">{{ row.elapsed || '-' }}</td>
              <td class="text-center" width="10%">
                <button class="btn btn-sm btn-primary mr-1" type="button"
                        @click="togglePayload(row)">
                  <i :class="isExpanded(row) ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
<!--                  {{ isExpanded(row) ? 'Hide' : 'View' }}-->
                </button>
                <button :disabled="isRowRefreshing(row)" class="btn btn-sm btn-secondary"
                        type="button" @click="refreshRow(row)">
                  <i :class="isRowRefreshing(row) ? 'fa fa-spin fa-spinner' : 'fa fa-refresh'"></i>
                </button>
                <pre v-if="isExpanded(row)" class="payload-box mt-2">{{ formatPayload(row) }}</pre>
              </td>
            </tr>
            </tbody>
            <tbody v-if="loader">
            <tr>
              <td colspan="9">
                <div class="loader"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import MultiSelect from "vue-multiselect";
import {db} from "@/firebase/init";

export default {
  name: "LxdLogs",
  components: {MultiSelect},
  data() {
    return {
      logs: [],
      loader: false,
      allClusters: [
        {name: 'LX4 (Testing)', value: 'lx4'},
        {name: 'ORD (Production)', value: 'ord'},
        {name: 'EGV (Production)', value: 'egv'},
        {name: 'IAD (Production)', value: 'iad'}
      ],
      selectedCluster: {},
      expandedRows: {},
      refreshing: false,
      refreshingRows: {},
    }
  },
  watch: {
    logs() {
      this.renderDatatable()
    },
    selectedCluster() {
      this.fetchLogs()
    }
  },
  mounted() {
    this.fetchLogs()
    this.renderDatatable()
  },
  methods: {
    rowKey(row) {
      return row.migration_id || `${row.instance}-${row.started_at}`;
    },
    isExpanded(row) {
      return !!this.expandedRows[this.rowKey(row)];
    },
    togglePayload(row) {
      const key = this.rowKey(row);
      this.$set(this.expandedRows, key, !this.expandedRows[key]);
    },
    formatPayload(row) {
      const clone = { ...row };
      if (clone.started_at instanceof Date) {
        clone.started_at = clone.started_at.toISOString();
      }
      if (clone.completed_at instanceof Date) {
        clone.completed_at = clone.completed_at.toISOString();
      }
      return JSON.stringify(clone, null, 2);
    },
    openDetails(row) {
      if (row && row.cluster) {
        localStorage.setItem('cluster', row.cluster)
      }
      if (row && row.instance) {
        this.$router.push({name: 'lxd-details', params: {id: row.instance}})
      }
    },
    renderDatatable() {
      if ($.fn.DataTable.isDataTable('#lxd_logs_datatable')) {
        $(`#lxd_logs_datatable`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#lxd_logs_datatable`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo": false,
          "ordering": true,
          order: [[5, 'desc']],
          columnDefs: [
            {targets: 8, orderable: false, searchable: false}
          ],
          initComplete: function () {
            let api = this.api();
            $('.dataTables_filter input').on('input', function () {
              let newValue = $(this).val().replace(/\s/g, '');
              $(this).val(newValue);
              api.search(newValue).draw();
            });
          }
        });
      }, 0)
    },
    formatDate(date) {
      if (!date) return '-';
      // Treat incoming timestamps as UTC, then convert to the user's local timezone
      const parsed = moment.utc(date).local();
      return parsed.isValid() ? parsed.format("D MMM, YYYY hh:mm A") : date;
    },
    formatStatus(status) {
      if (!status) return '-';
      return status
          .toString()
          .replace(/_/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase());
    },
    statusBadgeClass(status) {
      const s = (status || '').toLowerCase();
      if (s === 'completed' || s === 'success' || s === 'done') return 'badge-success';
      if (s === 'failed' || s === 'error') return 'badge-danger';
      if (s === 'in_progress' || s === 'running' || s === 'pending') return 'badge-warning';
      return 'badge-warning';
    },
    progressLabel(row) {
      if (row && typeof row.copy_progress === 'number' && row.copy_progress > 0) {
        return `copy ${row.copy_progress}%`;
      }
      return 'progress';
    },
    progressBarStyle(progress) {
      const percent = Number(progress) || 0;
      const gradientColors = [
        '#2ecc40',
        '#a3e635',
        '#eab308',
        '#f97316',
        '#ef4444',
        '#b91c1c',
        '#7f1d1d'
      ];
      let gradient;
      if (percent <= 20) {
        gradient = `linear-gradient(to right, ${gradientColors[0]}, #27ae60)`;
      } else if (percent <= 40) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 2).join(',')})`;
      } else if (percent <= 60) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 3).join(',')})`;
      } else if (percent <= 75) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 4).join(',')})`;
      } else if (percent <= 90) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 5).join(',')})`;
      } else if (percent <= 95) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 6).join(',')})`;
      } else {
        gradient = 'linear-gradient(to right, #a3e635, #2ecc40)';
      }
      return {
        width: percent + '%',
        background: gradient,
        transition: 'width 0.5s ease, background 0.5s ease'
      };
    },
    normalizeRow(data) {
      return {
        migration_id: data.migration_id || '',
        instance: data.instance || '',
        cluster: data.cluster || '',
        status: data.status || '',
        step: data.step || 0,
        total_steps: data.total_steps || 0,
        step_name: data.step_name || '',
        progress: typeof data.progress === 'number' ? data.progress : 0,
        progress_bar: data.progress_bar || '',
        copy_progress: typeof data.copy_progress === 'number' ? data.copy_progress : 0,
        source_node: data.source_node || '',
        target_node: data.target_node || '',
        node_group: data.node_group || '',
        profiles: Array.isArray(data.profiles) ? data.profiles : [],
        obsolete_instance: data.obsolete_instance || '',
        started_at: data.started_at && data.started_at
            ? data.started_at
            : data.started_at || null,
        completed_at: data.completed_at && data.completed_at
            ? data.completed_at
            : data.completed_at || null,
        elapsed: data.elapsed || '',
        error: data.error || '',
        db_synced: !!data.db_synced
      };
    },
    async fetchLogs() {
      try {
        this.logs = []
        this.loader = true;
        let query = db.collection('nodeGroupLogs').orderBy('started_at', 'desc');
        const snap = await query.get();
        this.logs = snap.docs.map(doc => this.normalizeRow(doc.data() || {}));
      } catch (e) {
        console.log('error fetching lxd logs', e)
      } finally {
        this.loader = false;
      }
    },
    isRowRefreshing(row) {
      return !!this.refreshingRows[this.rowKey(row)];
    },
    async refreshRow(row) {
      console.log('row', row)
      const key = this.rowKey(row);
      try {
        this.$set(this.refreshingRows, key, true);
        if (row.migration_id) {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action: 'refresh_status_for_node_migration',
            data: {
              migrationId: row.migration_id,
              cluster: row.cluster,
              name: row.instance,
              node_group: row.node_group,
              action: 'start',
            }
          })
        }
        let latest = null;
        if (row.migration_id) {
          const snap = await db.collection('nodeGroupLogs')
              .where('migration_id', '==', row.migration_id)
              .limit(1)
              .get();
          if (!snap.empty) {
            latest = this.normalizeRow(snap.docs[0].data() || {});
          }
        }
        if (latest) {
          const idx = this.logs.findIndex(r => this.rowKey(r) === key);
          if (idx !== -1) {
            this.$set(this.logs, idx, latest);
          }
        }
        this.showToast({
          message: 'Row refreshed.',
          duration: 1500
        }, true, 'success');
      } catch (e) {
        console.log('error refreshing row', e);
        this.showToast({
          message: `Something went wrong! ${e.toString()}`,
          duration: 2000
        }, true, 'danger');
      } finally {
        this.$set(this.refreshingRows, key, false);
      }
    },
    async refreshLogs() {
      try {
        this.refreshing = true;
        await this.fetchLogs();
        this.showToast({
          message: 'Logs refreshed successfully.',
          duration: 1500
        }, true, 'success');
      } catch (e) {
        console.log('error refreshing lxd logs', e);
        this.showToast({
          message: `Something went wrong! ${e.toString()}`,
          duration: 2000
        }, true, 'danger');
      } finally {
        this.refreshing = false;
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin: 20px
}

.badge-success {
  background-color: #ddf6e8;
  color: #6bd098;
  font-weight: 700;
}

.badge-warning {
  background-color: #fff0e1;
  color: #fbc658;
  font-weight: 700;
}

.badge-danger {
  background-color: #FDEEED;
  color: #EE8157;
  font-weight: 700;
}

.badge-info {
  background-color: #e7f0ff;
  color: #3b82f6;
  font-weight: 600;
}

.fs-12 {
  font-size: 12px;
}

.payload-box {
  display: block;
  text-align: left;
  background: #1e1e2f;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.4;
  padding: 10px 12px;
  border-radius: 6px;
  max-height: 360px;
  max-width: 440px;
  overflow: auto;
  white-space: pre;
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  margin: 0;
}
</style>
